import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Clock, CheckCircle, ArrowRight, Loader2 } from 'lucide-react';
import { useRecap, PeriodeTabs, Vide, dateFr } from './RecapCommun';

const STATUTS = {
  competent: { l: 'Compétent', c: 'bg-green-100 text-green-700' },
  en_cours: { l: 'En cours', c: 'bg-amber-100 text-amber-700' },
  non_competent: { l: 'Non compétent', c: 'bg-red-100 text-red-700' },
};

const TuteurCarte = ({ t }) => (
  <div className="min-w-0 rounded-xl border border-slate-200 bg-white p-4 space-y-3" data-testid={`recap-tuteur-${t.tuteur_id}`}>
    <div className="flex flex-wrap items-center justify-between gap-2">
      <p className="font-semibold text-[#0F172A]">{t.nom}</p>
      <div className="flex flex-wrap gap-2 text-xs">
        <span className="rounded-full bg-orange-100 px-2 py-0.5 text-orange-700">{t.nb_sessions} session{t.nb_sessions > 1 ? 's' : ''}</span>
        <span className="rounded-full bg-slate-100 px-2 py-0.5 text-slate-700"><Clock className="inline h-3 w-3 mr-1" />{t.heures} h</span>
        <span className="rounded-full bg-green-100 px-2 py-0.5 text-green-700"><CheckCircle className="inline h-3 w-3 mr-1" />{t.nb_competent} compétent</span>
      </div>
    </div>
    <div className="divide-y divide-slate-100 rounded-lg border border-slate-100">
      {t.dernieres.map(s => (
        <div key={s.session_id} className="px-3 py-2 text-xs">
          <div className="flex items-center justify-between gap-2">
            <span className="min-w-0 sm:truncate text-slate-600">{dateFr(s.date)} · <strong className="text-slate-800">{s.stagiaire}</strong> · {s.categorie} — {s.sous_categorie}</span>
            <span className={`shrink-0 rounded-full px-2 py-0.5 font-medium ${STATUTS[s.statut]?.c || 'bg-slate-100 text-slate-600'}`}>{STATUTS[s.statut]?.l || s.statut}</span>
          </div>
          {s.appreciation && <p className="mt-1 italic text-slate-500">« {s.appreciation} »</p>}
        </div>
      ))}
    </div>
  </div>
);

export const RecapTuteurs = () => {
  const [jours, setJours] = useState(7);
  const data = useRecap('/dashboard/recap-tuteurs', jours);
  return (
    <div className="rounded-2xl border border-orange-200 bg-orange-50/40 p-4 sm:p-5 space-y-4" data-testid="recap-tuteurs">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <PeriodeTabs value={jours} onChange={setJours} testId="recap-tuteurs-periode" />
        <Link to="/recapitulatif-autonomies" className="inline-flex items-center gap-1 text-sm font-medium text-orange-700 hover:underline" data-testid="lien-autonomies">
          Récapitulatif des autonomies <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
      {!data ? <div className="flex justify-center py-6"><Loader2 className="h-6 w-6 animate-spin text-orange-500" /></div>
        : data.erreur ? <Vide>Récap indisponible pour le moment.</Vide>
        : data.tuteurs.length === 0 ? <Vide>Aucune évaluation tuteur sur cette période.</Vide>
        : <div className="grid grid-cols-1 gap-3 lg:grid-cols-2">{data.tuteurs.map(t => <TuteurCarte key={t.tuteur_id} t={t} />)}</div>}
    </div>
  );
};
